
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/experts",
      function () {
        return require("private-next-pages/experts/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/experts"])
      });
    }
  